<table-datatable
  class="notification-table"
  [datatableConfig]="datatableConfig()"
  [displayColumns]="displayColumns()"
  [data]="rules()"
>
</table-datatable>
